/**
 * Handle attempts to access data that requires a logout (redirects the user
 * to the logout page, with a URL set so that they can return)
 */
import {useLocation} from "react-router-dom-v5-compat";

import {getLogoutUrl, redirect} from "@khan/urls";

import FullPageSpinner from "../full-page-spinner/full-page-spinner.tsx";

const LogoutRequired = () => {
    // If the user is logged in then we redirect them to
    // the logout page (which will redirect them back to this
    // page after a successful logout)
    const {pathname, search, hash} = useLocation();
    const continueUrl = pathname + search + hash;
    const url = getLogoutUrl(continueUrl);
    redirect(url);
    return <FullPageSpinner />;
};
export default LogoutRequired;
